'use strict';

export function sortByNameProp(a, b) {
  if (!a.employee) {
    return -1;
  }
  if (!b.employee) {
    return 1;
  }
  var nameA = a.employee.name.toUpperCase();
  var nameB = b.employee.name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}

export function sortByProp(prop) {
  const sorting = (a, b) => {
    if (!a[prop]) {
      return -1;
    }
    if (!b[prop]) {
      return 1;
    }
    if (a[prop] < b[prop]) {
      return -1;
    }
    if (a[prop] > b[prop]) {
      return 1;
    }
    return 0;
  };
  return sorting;
}
